import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import setDate from '../../utils/setDate';

const ExperimentRecords = ({ classes, experiments }) => {
    return (
        <>
            <Typography variant="h4" component="h4" align="left">Experiments</Typography>
            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Created At</TableCell>
                            <TableCell variant="head">Experiment</TableCell>
                            <TableCell variant="head">Variant</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {experiments.map(experiment => (
                            <TableRow key={experiment.id}>
                                <TableCell variant="body">{setDate(experiment.createdAt)}</TableCell>
                                <TableCell variant="body">{experiment.experiment}</TableCell>
                                <TableCell variant="body">{experiment.variant}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </>
    );
};

ExperimentRecords.propTypes = {
    classes: PropTypes.shape({
        paper: PropTypes.string.isRequired,
        table: PropTypes.string.isRequired,
    }).isRequired,
    experiments: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        createdAt: PropTypes.string.isRequired,
        experiment: PropTypes.string.isRequired,
        variant: PropTypes.string.isRequired,
    })).isRequired,
};

export default ExperimentRecords
